import { createRoute, redirect } from '@tanstack/react-router';
import BookingSummaryPage from '@/features/public/booking/pages/BookingSummaryPage.tsx';
import {
  bookingDraftKey,
  draftOf,
  useBookingStore,
} from '@/features/public/booking/context/bookingStore.tsx';
import { bookingRoute } from '@/features/public/booking/routes/bookingRoutes.ts';
import { FunnelEventStage } from '@/features/public/booking/tracking/FunnelEventStage.ts';
import { trackFunnelStage } from '@/features/public/booking/tracking/funnelTracker.ts';

export const bookingSummaryRoute = createRoute({
  getParentRoute: () => bookingRoute,
  path: '/summary',
  component: BookingSummaryPage,
  // Tylko guard - samo podsumowanie (z rabatami) liczone jest w komponencie
  // przez useQuery, aby przeliczać się po zmianie kodów promocyjnych.
  loader: ({ params: { orgSlug, tourSlug } }) => {
    const draft = draftOf(
      useBookingStore.getState(),
      bookingDraftKey(orgSlug, tourSlug),
    );
    if (!draft.clientFormData) {
      throw redirect({ to: '..' });
    }

    trackFunnelStage(orgSlug, tourSlug, FunnelEventStage.SUMMARY_VIEWED);
  },
});
